"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=collapsed-edge.js.map